// Service Worker Registration (No Cache)
// This file handles service worker registration without caching

export function register(config) {
  // Service worker registration is disabled - no caching
  console.log("Service worker registration is disabled");
  return;
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log("Service worker unregistered");
      })
      .catch((error) => {
        console.error("Error unregistering service worker:", error.message);
      });
  }
}

// Simple reload function without cache clearing
export function forceRefresh() {
  window.location.reload(true);
}

// No cache detection - always return false
export function detectCacheIssues() {
  return false;
}

// Simple version tracking without cache management
export function addVersionToManifest() {
  const version = process.env.REACT_APP_VERSION || Date.now().toString();
  document.documentElement.setAttribute("data-version", version);
}
